import { useState } from 'react';

export type NewPasswordPayload = {
  password: string;
};

const useVerifyRecruiter = (token: string | null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const verifyRecruiter = async (
    payload: NewPasswordPayload,
    successCallback: () => void
  ) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/recruiter/verify`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      if (response.status !== 200) {
        setIsError(true);
      } else {
        successCallback();
      }
    } catch (error) {
      console.log(error, 'error');
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return { verifyRecruiter, isLoading, isError };
};

export default useVerifyRecruiter;
